/* Suspendre les invitations publiques — DS-06 (Bible §20 · MER-115).
   Owner/Admin one-switch pause of public asks. Gifts, Mes cadeaux and
   redemption keep working: this pauses the ask, never the promise.
   Distinct from BMR’s provider-wide emergency disable (DS-07). */
import { useNavigate } from 'react-router-dom'
import { Button, Card, ErrorState, KV } from '@/ui'
import { usePauseImpact } from './api'
import { Chargement, Retour } from './parts'

export default function Suspendre() {
  const { data, isPending, isError, refetch } = usePauseImpact()
  const nav = useNavigate()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de calculer l’impact de la suspension."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = data
  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 620 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Suspendre les invitations publiques</h2>

      <KV rows={[
        ['Établissements concernés', <span key="p"><b>{d.scope}</b> · sélection possible</span>],
        ['Bascule', <span key="b">vers <b>{d.fallback}</b> (ou Cadeau seul)</span>],
      ]} />

      <Card>
        <p className="f-help" style={{ margin: 0 }}>
          Impact&nbsp;: {d.campaigns} campagnes, {d.stages} étapes, {d.scheduledMessages} messages
          programmés. Les clients voient l’expérience de repli — cadeaux, Mes cadeaux et
          validations continuent normalement.
        </p>
      </Card>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button variant="danger" size="sm">Suspendre les invitations</Button>
        <Button variant="quiet" size="sm" onClick={() => nav('/destinations')}>Annuler</Button>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        Réversible. La reprise exige guide à jour + confirmations fraîches + un test par
        parcours concerné.
      </p>
    </div>
  )
}
